<div class="ion-padding adx">
  <div class="adx-fej">
    <h2><ion-icon name="code-download-outline"></ion-icon> Adatexport (JSON)</h2>
    <ion-button size="small" (click)="ujMegnyit()" [disabled]="fut || !adatkorok.length">
      <ion-icon slot="start" name="add-outline"></ion-icon>Új kulcs
    </ion-button>
  </div>
  <p class="adx-halvany">
    A KRÉTA öt exportjának (tanulók tantárgyai és pedagógusai, szülők elérhetőségei, osztályba járó tanulók,
    mulasztások, jegyek) gépi megfelelője – a SULINFORM saját adataiból, adatkörönként külön JSON-címen, amit egy
    kimutatás (BI-eszköz, táblázat, szkript) közvetlenül be tud olvasni. A mezők neve a KRÉTA oszlopait követi;
    minden válasz <code>mezok</code> listája megmondja, melyik mező melyik KRÉTA-oszlopnak felel meg.
  </p>

  <div class="adx-figyelem" role="note">
    <ion-icon name="warning-outline"></ion-icon>
    <div>
      <b>A link maga a hozzáférés.</b> Aki a címet megkapja, bejelentkezés nélkül látja a benne lévő személyes
      adatokat (név, oktatási azonosító, cím, telefonszám, mulasztás, jegy). Csak biztonságos csatornán add át
      (pl. személyesen vagy titkosított üzenetben – ne nyílt e-mailben, ne csoportos csevegőben), és csak annak,
      akinek a munkájához kell. Ha a cím rossz kezekbe kerülhetett, azonnal kérj új kulcsot vagy vond vissza.
    </div>
  </div>

  <ion-note color="danger" class="adx-hiba" *ngIf="hiba">{{ hiba }}</ion-note>

  <!-- A FRISSEN KIADOTT CÍMEK – csak most látszanak -->
  <section class="adx-kartya adx-kiadott" *ngIf="kiadott">
    <div class="adx-kartya-fej">
      <h3>Az új címek – „{{ kiadott.megnevezes }}”</h3>
      <ion-button fill="clear" size="small" (click)="kiadott = null" aria-label="Bezárás"><ion-icon name="close"></ion-icon></ion-button>
    </div>
    <p class="adx-halvany">
      <b>Csak most látszanak.</b> Másold ki és add át őket; a képernyő bezárása után a teljes cím már nem kérhető
      le – csak új kulcs adható ki.
    </p>
    <div class="adx-cim" *ngFor="let l of kiadottLista()">
      <div class="adx-cim-nev">{{ l.cim }}</div>
      <div class="adx-cim-sor">
        <code class="adx-url">{{ teljesCim(l.ut) }}</code>
        <ion-button size="small" fill="outline" (click)="masol(l.ut)"><ion-icon slot="start" name="copy-outline"></ion-icon>Másolás</ion-button>
      </div>
    </div>
    <div class="adx-gombok">
      <ion-button size="small" fill="outline" (click)="mindetMasol()"><ion-icon slot="start" name="copy-outline"></ion-icon>Mindet másolom</ion-button>
    </div>
    <p class="adx-halvany adx-kicsi">
      Paraméterek: <code>?tanev=2026</code> (a tanév kezdőéve, alapból a folyó tanév), a mulasztásoknál és a
      jegyeknél <code>?tol=ÉÉÉÉ-HH-NN&amp;ig=ÉÉÉÉ-HH-NN</code> (alapból a tanév eleje → ma). Kulcsonként legfeljebb
      60 lekérés 10 percenként.
    </p>
  </section>

  <!-- KULCSOK -->
  <section class="adx-kartya" *ngIf="betoltve">
    <h3>Kiadott kulcsok</h3>
    <div class="adx-halvany" *ngIf="!kulcsok.length">Még nincs kiadott kulcs.</div>
    <div class="adx-tabla-wrap" *ngIf="kulcsok.length">
      <table class="adx-tabla">
        <thead>
          <tr><th>Megnevezés</th><th>Adatkörök</th><th>Létrehozva</th><th>Utolsó lekérés</th><th class="szam">Lekérések</th><th>Állapot</th><th></th></tr>
        </thead>
        <tbody>
          <ng-container *ngFor="let k of kulcsok">
            <tr [class.adx-ki]="!k.aktiv">
              <td><b>{{ k.megnevezes }}</b><div class="adx-kicsi adx-halvany">kulcs: {{ k.token_eleje }}…</div></td>
              <td>{{ adatkorNevek(k.adatkorok) }}</td>
              <td>{{ k.letrehozva | slice:0:16 }}<div class="adx-kicsi adx-halvany" *ngIf="k.letrehozta">{{ k.letrehozta }}</div></td>
              <td>{{ k.utolso_keres ? (k.utolso_keres | slice:0:16) : '—' }}</td>
              <td class="szam">{{ k.keresek }}</td>
              <td>
                <span class="adx-cimke" [class.el]="k.aktiv">{{ k.aktiv ? 'él' : 'visszavonva' }}</span>
                <div class="adx-kicsi adx-halvany" *ngIf="!k.aktiv">{{ k.visszavonva | slice:0:16 }}{{ k.visszavonta ? ' · ' + k.visszavonta : '' }}</div>
              </td>
              <td class="adx-muvelet">
                <ion-button size="small" fill="clear" (click)="naploValt(k)">Napló</ion-button>
                <ion-button size="small" fill="clear" *ngIf="k.aktiv" (click)="ujraGeneral(k)" [disabled]="fut">Új kulcs</ion-button>
                <ion-button size="small" fill="clear" color="danger" *ngIf="k.aktiv" (click)="visszavon(k)" [disabled]="fut">Visszavonás</ion-button>
              </td>
            </tr>
            <tr *ngIf="naploNyitva === k.id" class="adx-naplo-sor">
              <td colspan="7">
                <div class="adx-halvany" *ngIf="!naplo.length">Még nem kérték le (vagy a 90 napos napló üres).</div>
                <table class="adx-tabla adx-kicsi" *ngIf="naplo.length">
                  <thead><tr><th>Idő</th><th>Adatkör</th><th>Honnan (IP)</th><th class="szam">Sorok</th><th>Eredmény</th></tr></thead>
                  <tbody>
                    <tr *ngFor="let n of naplo">
                      <td>{{ n.idopont }}</td><td>{{ n.adatkor === 'index' ? 'tartalomjegyzék' : adatkorNev(n.adatkor) }}</td>
                      <td>{{ n.ip || '—' }}</td><td class="szam">{{ n.sorok ?? '—' }}</td>
                      <td [class.adx-piros]="n.statusz !== 200">{{ n.statusz === 200 ? 'rendben' : (n.statusz === 403 ? 'nem engedett adatkör' : 'hiba') }}</td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
          </ng-container>
        </tbody>
      </table>
    </div>
  </section>
</div>

<!-- ÚJ KULCS -->
<ion-modal [isOpen]="ujNyitva" (didDismiss)="ujNyitva = false">
  <ng-template>
    <ion-header>
      <ion-toolbar color="primary">
        <ion-title>Új adatexport-kulcs</ion-title>
        <ion-buttons slot="end">
          <ion-button (click)="ujNyitva = false" aria-label="Bezárás"><ion-icon name="close"></ion-icon></ion-button>
        </ion-buttons>
      </ion-toolbar>
    </ion-header>
    <ion-content class="ion-padding">
      <label class="adx-mezo">Megnevezés (kinek, mire)
        <input type="text" [(ngModel)]="ujNev" maxlength="200" placeholder="pl. Papp András – BI kimutatás">
      </label>
      <div class="adx-mezo-cim">Adatkörök</div>
      <div class="adx-adatkorok">
        <label *ngFor="let a of adatkorok" class="adx-adatkor" [class.be]="ujAdatkorok[a.adatkor]">
          <input type="checkbox" [(ngModel)]="ujAdatkorok[a.adatkor]">
          <span><b>{{ a.megnevezes }}</b><small>{{ a.leiras }}</small></span>
        </label>
      </div>
      <div class="adx-figyelem adx-kicsi">
        <ion-icon name="warning-outline"></ion-icon>
        <div>Csak azt az adatkört jelöld ki, amire a kimutatáshoz valóban szükség van. A kész címek egyszer
          jelennek meg – utána csak új kulcs kérhető.</div>
      </div>
      <div class="adx-gombok">
        <ion-button fill="outline" (click)="ujNyitva = false">Mégse</ion-button>
        <ion-button (click)="letrehoz()" [disabled]="fut || !ujNev.trim() || !ujKijelolt.length">Kulcs kiadása</ion-button>
      </div>
    </ion-content>
  </ng-template>
</ion-modal>
